import { render, staticRenderFns } from "./NotificationTemplates.vue?vue&type=template&id=565b64a0&scoped=true&"
import script from "./NotificationTemplates.vue?vue&type=script&lang=js&"
export * from "./NotificationTemplates.vue?vue&type=script&lang=js&"
import style0 from "./NotificationTemplates.vue?vue&type=style&index=0&id=565b64a0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "565b64a0",
  null
  
)

export default component.exports